<template>
    <div>
        <el-row>
            <el-col :span="24" style="text-align: left; padding-top: 30px;">
                <span class="mainTitle">
                    Contact us
                </span>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24"  style="text-align: left;padding:20px 60px;">
                <span  class="mainContent">
                    <el-row>
                        <el-col :span="8" style="padding-right: 15px;">
                            <el-card :body-style="{ padding: '0px' }">
                                <div style="padding: 14px">
                                <span><b>ZHOUSHAN CHENXI NEW MATERIAL CO.,LTD.</b></span>
                                <div class="bottom">
                                    <b>Tel：</b>0086-181 2121 7006<br>
                                    <b>E-mail：</b><a href="mailto:zhaoboya@chenxichem.com">zhaoboya@chenxichem.com</a><br>
                                    <b>Add：</b>No.10-1006, Block B, No.116 Yingbin Ave., Xingang Park, Zhoushan Economic Dev. Zone, (Comprehensive Bonded Zone), Beichan Township, Dinghai Dist., Zhoushan City, China (Zhejiang) Pilot Free Trade Zone<br>
                                </div>
                                </div>
                            </el-card>
                        </el-col>
                        <el-col :span="16" style="padding:0 15px;">
                            <el-card :body-style="{ padding: '0px' }">
                                <div style="padding: 14px">
                                <div class="bottom">
                                    <img src="../../../../assets/images/contactUs.png" class="mainPic"/>
                                </div>
                                </div>
                            </el-card>
                        </el-col>
                    </el-row>
                </span>
            </el-col>
            <!-- <el-col :span="24"  style="text-align: left;padding:0px 60px 40px 60px;">
                <img src="../../../../assets/images/contactUs.png" class="mainPic"/>
            </el-col> -->
            
        </el-row>
    </div>
</template>

<script>
    export default {
        name: "cn_contactus",
        components: {},
        data() {
            return {

            }
        }
    }
</script>